export const productSelectList = [
  {
    id: 1,
    title: "Tên sản phẩm",
    value: "name",
  },
  {
    id: 2,
    title: "Mã sản phẩm (SKU)",
    value: "sku",
  },
  {
    id: 3,
    title: "Phiếu công bố",
    value: "notificationNo",
  },
  {
    id: 4,
    title: "Mã vạch",
    value: "barcode",
  },
];
